module.exports = __webpack_public_path__ + "static/img/4.e57ac7e4.png";